// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.djW0M0zpnz2xZ3wIl78g{width:100vw;position:absolute;top:0;left:0;z-index:-1}.djW0M0zpnz2xZ3wIl78g .IVsmiLbC_rfPeuWIZpTO{width:100%;height:auto}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,4CACE,UAAA,CACA,WAAA","sourcesContent":[".Home {\n  width: 100vw;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  .cover {\n    width: 100%;\n    height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Home": `djW0M0zpnz2xZ3wIl78g`,
	"cover": `IVsmiLbC_rfPeuWIZpTO`
};
export default ___CSS_LOADER_EXPORT___;
